export const INVALID_FORM_FIELD_LABELS: Record<string, string> = {
  auditId: 'Audit ID',
  auditTitle: 'Audit Title',
  auditor: 'Audit Dep',
  reportingYear: 'Report Year',
  isSpecialAudit: 'Special Audit',
  assessmentCoordinator: 'Auditee',
  assessmentCoordinatorName: 'Auditee Name',
  legalUnitResponsibles: 'LU responsibles',
  legalUnitResponsiblesNames: 'LU responsibles Names',
  otherResponsibles: 'Other responsibles',
  otherResponsibleNames: 'Other responsibles Names',
  plant: 'Plant',
  concernsCountry: 'Concerns Country',
  legalUnit: 'Legal Unit',
  department: 'BG',
  concernsName: 'Concerns Name',
  status: 'Status',
  fileLinkId: 'File Link ID',
  emailAddress: 'Email Address',
  announcementSentTo: 'Announcement Sent To',
  announcementSentOn: 'Announcement Sent On',
  announcementSentBy: 'Announcement Sent By',
  authorsBinGen: 'Authors BinGen',
  assessor: 'Assessor',
  audRole: 'Audit Role',
  authorsAuditor: 'Authors Auditor',
  keypersons: 'Keypersons',
  myAttention: 'My Attention',
  readersBusinessGroup: 'Readers Business Group',
  readersLegalUnit: 'Readers Legal Unit',
  readersResponsible: 'Readers Responsible',
  isSendStartMail: 'Send Start Mail',
  id: 'ID',
  createdAt: 'Created At',
  modifiedAt: 'Modified At',
  createdBy: 'Created By',
  modifiedBy: 'Modified By',
  createdTick: 'Created Tick',
  modifiedTick: 'Modified Tick',
  newCreatedBy: 'New Created By',
  createdByUserId: 'Created By User ID'
};
